import React from "react";
import { Link } from 'react-router-dom'


import hero1 from '../../images/faxian-it-images/hero-img.jpg'
import hero2 from '../../images/slider/like.svg'
import VideoModal from "../ModalVideo/VideoModal";

const Hero3 = () => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="hero-slide">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="hero-slider-section">
                <div className="hero-bg">
                    <img src={hero1} alt="" />
                </div>

      
                 <div className="container">
                    <div className="content">
                    
                        <div className="title " >
                            <div className="icon">
                                <img src={hero2} alt="" />
                            </div>
                            <span>Your Trusted IT Consulting Partner</span>
                        </div>
                        <div className="sub-title " >
                            <h2>Empowering <span>Businesses</span> with Technology</h2>
                        </div>
                        <p >At FaxianIT, we combine experience and empathy to deliver IT solutions that accelerate your business growth and digital transformation.</p>
                        <div className="hero-btn">
                            <Link to="/contact" className="theme-btn">Get Started<i className="ti-arrow-right"></i></Link>
                        </div>
                  
                </div>
       </div>
                {/* <div className="video" >
                    <VideoModal />
                </div> */}
            </div>
            </div>
            </div>
        </section>

    )
}

export default Hero3;



